import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DsAngularModule } from '@snapon/design-system-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AdminAuthGuard } from 'core/auth-guard/admin-auth-guard.service';
import { AuthGuard } from 'core/auth-guard/auth-guard.service';
import { MobileGuard } from 'core/mobile-guard/mobile.guard.service';
import { UnsavedChangesGuard } from 'core/unsaved-changes/unsaved-changes-guard.class';
import { MatButtonModule } from '@angular/material/button';
import { AppRoutingModule } from '../../app-routing.module';
import { SafePipe } from '../marketing/safe.pipe';
import { OrderListComponent } from '../pos/orders/order-list/order-list.component';
import { AppMaterialModule } from '../../app-material.module';
import { InvoiceListComponent } from '../pos/invoices/invoices-list/invoices-list.component';
import {
  QuotesSubsectionsFilterFormComponent
} from '../pos/quotes/quotes-subsections-filter-form/quotes-subsections-filter-form.component';
import { LnOrderListComponent } from '../pos/ln-orders/ln-order-list/ln-order-list.component';
import { LastQuotesSearchComponent } from
  '../marketing/products/product-details/last-quotes-list/last-quotes-search/last-quotes-search.component';
import { BreadcrumbsComponent } from '../marketing/products/breadcrumbs/breadcrumbs.component';
import { LastQuotesFiltersComponent } from
  '../marketing/products/product-details/last-quotes-list/last-quotes-search/last-quotes-filters/last-quotes-filters.component';
import { QuotesSubsectionsTogglesComponent } from '../pos/quotes/quotes-subsections-toggles/quotes-subsections-toggles.component';
import { PaginationComponent } from './pagination/pagination.component';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { ClickOutsideDirective } from './click-outside/click-outside.directive';
import { DigitsOnlyDirective } from './digits-only/digits-only.directive';
import { EmailInputComponent } from './email-input/email-input.component';
import { GoOfflineSyncInProgressScreenComponent } from './go-offline-sync-in-progress-screen/go-offline-sync-in-progress-screen.component';
import { IconComponent } from './icon/icon.component';
import { NoInternetConnectionComponent } from './no-internet-connection/no-internet-connection.component';
import { OfflineNoInternetConnectionComponent } from './offline-internet-connection-required/offline-no-internet-connection.component';
import { OfflineLoginScreenComponent } from './offline-login-screen/offline-login-screen.component';
import { SpecialCharactersValidationsDirective } from './specialCharactersValidations/special-characters-validations.directive';
import { NoWhiteSpacesAllowedDirective } from './noWhiteSpacesAllowed/no-white-spaces-allowed.directive';
import { DragDropDirective } from './drag-drop/drag-drop.directive';
import { CountrySelectComponent } from './country-select/country-select.component';
import { MatchBoldPipe } from './match-upper/matchBold.pipe';
import { IsMobileDirective } from './is-mobile/is-mobile.directive';
import { IsDesktopDirective } from './is-mobile/is-desktop.directive';
import { DateAgoPipe } from './date-ago/date-ago.pipe';
import { NumericInputDirective } from './numeric-input/numeric-input.directive';
import { FileSizePipe } from './file-size/file-size.pipe';

@NgModule({
  declarations: [
    PaginationComponent,
    IconComponent,
    DigitsOnlyDirective,
    AccessDeniedComponent,
    ClickOutsideDirective,
    EmailInputComponent,
    SafePipe,
    OfflineNoInternetConnectionComponent,
    OfflineLoginScreenComponent,
    GoOfflineSyncInProgressScreenComponent,
    NoInternetConnectionComponent,
    SpecialCharactersValidationsDirective,
    NoWhiteSpacesAllowedDirective,
    OrderListComponent,
    InvoiceListComponent,
    QuotesSubsectionsFilterFormComponent,
    LnOrderListComponent,
    LastQuotesSearchComponent,
    DragDropDirective,
    CountrySelectComponent,
    MatchBoldPipe,
    IsMobileDirective,
    IsDesktopDirective,
    BreadcrumbsComponent,
    LastQuotesFiltersComponent,
    DateAgoPipe,
    QuotesSubsectionsTogglesComponent,
    NumericInputDirective,
    FileSizePipe
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    MatTableModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    AppMaterialModule,
    DsAngularModule
  ],
  providers: [
    UnsavedChangesGuard,
    AdminAuthGuard,
    AuthGuard,
    MobileGuard,
  ],
  exports: [
    PaginationComponent,
    IconComponent,
    DigitsOnlyDirective,
    SpecialCharactersValidationsDirective,
    NoWhiteSpacesAllowedDirective,
    ClickOutsideDirective,
    EmailInputComponent,
    SafePipe,
    FormsModule,
    ReactiveFormsModule,
    OrderListComponent,
    InvoiceListComponent,
    AppMaterialModule,
    QuotesSubsectionsFilterFormComponent,
    LnOrderListComponent,
    LastQuotesSearchComponent,
    DragDropDirective,
    MatchBoldPipe,
    IsDesktopDirective,
    IsMobileDirective,
    BreadcrumbsComponent,
    LastQuotesFiltersComponent,
    DateAgoPipe,
    DsAngularModule,
    QuotesSubsectionsTogglesComponent,
    NumericInputDirective,
    FileSizePipe
  ]
})
export class SharedModule {
}
